'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NitroGrids = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  min-width: 100%;\n  min-width: calc(100% + 18px);\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin: 0 -9px;\n\n  ', '\n'], ['\n  min-width: 100%;\n  min-width: calc(100% + 18px);\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin: 0 -9px;\n\n  ', '\n']);

var _propTypes = require('prop-types');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var NitroGrids = exports.NitroGrids = _styledComponents2.default.section(_templateObject, function (props) {
  return props.noMargin && '\n    margin: 0;\n    min-width: 100%;\n  ';
});

NitroGrids.displayName = 'NitroGrids';
NitroGrids.propTypes = {
  noMargin: _propTypes.PropTypes.bool
};

exports.default = NitroGrids;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-grids/NitroGrids.js
// module id = 2910
// module chunks = 4